import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import { defineComponent, ref } from "vue";
/**
 * Component with search
 *
 * @component
 * @example
 * <search-filter />
 */

export default defineComponent({
  name: "SearchFilter",
  props: {
    placeholder: {
      type: String,
      default: ""
    },
    search: {
      type: String,
      default: ""
    }
  },
  emits: ["search-filter:changed"],
  setup: function setup(props, context) {
    var searchValue = ref(props.search);
    /**
     * Return input value
     *
     * @params {string} value: incoming input value
     * @returns {string}
     */

    var onSearchChange = function onSearchChange(value) {
      context.emit("search-filter:changed", value);
    };

    return {
      searchValue: searchValue,
      onSearchChange: onSearchChange
    };
  }
});